import { useRouter } from "next/router"
import { useEffect, useRef } from "react"
import { gotoWithoutQuery } from "../../../_common/routing"
import { useECommerceMachine } from "../../../_common/machines/machines-context"

export const useHandleGotoWebQuoteThankYou = (afterGoto?: () => void) => {
    const router = useRouter()
    const [state] = useECommerceMachine()
    const isExecuting = useRef(false)

    const isWebQuoteValidated = state.matches("flow.webQuote.webQuoteValidated")
    useEffect(() => {
        if (isWebQuoteValidated && !isExecuting.current) {
            isExecuting.current = true
            gotoWithoutQuery(router, state.context.flowVersion.router.route("modal-quote-thank-you"))
                .then(() => {
                    afterGoto?.()
                    isExecuting.current = false
                })
                .catch(() => {
                    isExecuting.current = false
                })
        }
    }, [isWebQuoteValidated, router])
}
